"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _BasicConnectivityStatus = _interopRequireDefault(require("./BasicConnectivityStatus"));

var _BasicSendBox = _interopRequireDefault(require("./BasicSendBox"));

var _BasicToaster = _interopRequireDefault(require("./BasicToaster"));

var _BasicTranscript = _interopRequireDefault(require("./BasicTranscript"));

var _Composer = _interopRequireDefault(require("./Composer"));

var _concatMiddleware = _interopRequireDefault(require("./Middleware/concatMiddleware"));

var _createCoreMiddleware = _interopRequireDefault(require("./Middleware/Activity/createCoreMiddleware"));

var _createCoreMiddleware2 = _interopRequireDefault(require("./Middleware/ActivityStatus/createCoreMiddleware"));

var _createCoreMiddleware3 = _interopRequireDefault(require("./Middleware/Attachment/createCoreMiddleware"));

var _createCoreMiddleware4 = _interopRequireDefault(require("./Middleware/Avatar/createCoreMiddleware"));

var _createCoreMiddleware5 = _interopRequireDefault(require("./Middleware/Toast/createCoreMiddleware"));

var _createCoreMiddleware6 = _interopRequireDefault(require("./Middleware/TypingIndicator/createCoreMiddleware"));

var _ErrorBox = _interopRequireDefault(require("./ErrorBox"));

var _TypeFocusSink = _interopRequireDefault(require("./Utils/TypeFocusSink"));

var _useTrackException = _interopRequireDefault(require("./hooks/useTrackException"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  flexDirection: 'column'
});
var CONNECTIVITY_STATUS_CSS = (0, _glamor.css)({
  flexShrink: 0
});
var SEND_BOX_CSS = (0, _glamor.css)({
  flexShrink: 0
});
var TOASTER_CSS = (0, _glamor.css)({
  flexShrink: 0
});
var TRANSCRIPT_CSS = (0, _glamor.css)({
  flex: 1
});

var SilentError = function SilentError(_ref) {
  var err = _ref.err,
      message = _ref.message;
  var trackException = (0, _useTrackException.default)();
  (0, _react.useEffect)(function () {
    trackException(err || new Error(message), false);
  }, [err, message, trackException]);
  return false;
}; // TODO: [P2] We should move these into <Composer>


function createActivityRenderer(additionalMiddleware) {
  var activityMiddleware = (0, _concatMiddleware.default)(additionalMiddleware, (0, _createCoreMiddleware.default)())({});
  return function () {
    try {
      return activityMiddleware(function (_ref2) {
        var activity = _ref2.activity;
        return function () {
          return _react.default.createElement(SilentError, {
            message: "No activity found for type \"".concat(activity.type, "\".")
          });
        };
      }).apply(void 0, arguments);
    } catch (err) {
      var FailedRenderActivity = function FailedRenderActivity() {
        return _react.default.createElement(_ErrorBox.default, {
          error: err,
          message: "Failed to render activity"
        }, _react.default.createElement("pre", null, JSON.stringify(err, null, 2)));
      };

      return FailedRenderActivity;
    }
  };
} // TODO: [P2] #2859 We should move these into <Composer>


function createActivityStatusRenderer(additionalMiddleware) {
  var activityStatusMiddleware = (0, _concatMiddleware.default)(additionalMiddleware, (0, _createCoreMiddleware2.default)())({});
  return function () {
    try {
      return activityStatusMiddleware(function () {
        return false;
      }).apply(void 0, arguments);
    } catch (err) {
      var message = err.message,
          stack = err.stack;
      return _react.default.createElement(_ErrorBox.default, {
        error: err,
        message: "Failed to render activity status"
      }, _react.default.createElement("pre", null, JSON.stringify({
        message: message,
        stack: stack
      }, null, 2)));
    }
  };
} // TODO: [P2] #2859 We should move these into <Composer>


function createAttachmentRenderer(additionalMiddleware) {
  var attachmentMiddleware = (0, _concatMiddleware.default)(additionalMiddleware, (0, _createCoreMiddleware3.default)())({});
  return function () {
    try {
      return attachmentMiddleware(function (_ref3) {
        var attachment = _ref3.attachment;
        return _react.default.createElement(_ErrorBox.default, {
          message: "No renderer for this attachment"
        }, _react.default.createElement("pre", null, JSON.stringify(attachment, null, 2)));
      }).apply(void 0, arguments);
    } catch (err) {
      return _react.default.createElement(_ErrorBox.default, {
        error: err,
        message: "Failed to render attachment"
      }, _react.default.createElement("pre", null, JSON.stringify(err, null, 2)));
    }
  };
} // TODO: [P2] #2859 We should move these into <Composer>


function createAvatarRenderer(additionalMiddleware) {
  var avatarMiddleware = (0, _concatMiddleware.default)(additionalMiddleware, (0, _createCoreMiddleware4.default)())({});
  return function () {
    try {
      return avatarMiddleware(function () {
        return false;
      }).apply(void 0, arguments);
    } catch (err) {
      console.error('Failed to render avatar', err);
    }
  };
} // TODO: [P2] #2859 We should move these into <Composer>


function createToastRenderer(additionalMiddleware) {
  var toastMiddleware = (0, _concatMiddleware.default)(additionalMiddleware, (0, _createCoreMiddleware5.default)())({});
  return function () {
    try {
      return toastMiddleware(function (_ref4) {
        var notification = _ref4.notification;
        return _react.default.createElement(_ErrorBox.default, {
          message: "No renderer for this notification"
        }, _react.default.createElement("pre", null, JSON.stringify(notification, null, 2)));
      }).apply(void 0, arguments);
    } catch (err) {
      var message = err.message,
          stack = err.stack;
      console.error({
        message: message,
        stack: stack
      });
      return _react.default.createElement(_ErrorBox.default, {
        error: err,
        message: "Failed to render notification"
      }, _react.default.createElement("pre", null, JSON.stringify({
        message: message,
        stack: stack
      }, null, 2)));
    }
  };
}

function createTypingIndicatorRenderer(additionalMiddleware) {
  var typingIndicatorMiddleware = (0, _concatMiddleware.default)(additionalMiddleware, (0, _createCoreMiddleware6.default)())({});
  return function () {
    try {
      return typingIndicatorMiddleware(function (_ref5) {
        var activeTyping = _ref5.activeTyping,
            typing = _ref5.typing,
            visible = _ref5.visible;
        return _react.default.createElement(_ErrorBox.default, {
          message: "No renderer for typing indicator"
        }, _react.default.createElement("pre", null, JSON.stringify({
          activeTyping: activeTyping,
          typing: typing,
          visible: visible
        }, null, 2)));
      }).apply(void 0, arguments);
    } catch (err) {
      var message = err.message,
          stack = err.stack;
      console.error({
        message: message,
        stack: stack
      });
      return _react.default.createElement(_ErrorBox.default, {
        error: err,
        message: "Failed to render typing indicator"
      }, _react.default.createElement("pre", null, JSON.stringify({
        message: message,
        stack: stack
      }, null, 2)));
    }
  };
}

var BasicWebChat = function BasicWebChat(_ref6) {
  var activityMiddleware = _ref6.activityMiddleware,
      activityStatusMiddleware = _ref6.activityStatusMiddleware,
      attachmentMiddleware = _ref6.attachmentMiddleware,
      avatarMiddleware = _ref6.avatarMiddleware,
      className = _ref6.className,
      toastMiddleware = _ref6.toastMiddleware,
      typingIndicatorMiddleware = _ref6.typingIndicatorMiddleware,
      otherProps = _objectWithoutProperties(_ref6, ["activityMiddleware", "activityStatusMiddleware", "attachmentMiddleware", "avatarMiddleware", "className", "toastMiddleware", "typingIndicatorMiddleware"]);

  var sendBoxRef = (0, _react.useRef)();
  var activityRenderer = (0, _react.useMemo)(function () {
    return createActivityRenderer(activityMiddleware);
  }, [activityMiddleware]);
  var activityStatusRenderer = (0, _react.useMemo)(function () {
    return createActivityStatusRenderer(activityStatusMiddleware);
  }, [activityStatusMiddleware]);
  var attachmentRenderer = (0, _react.useMemo)(function () {
    return createAttachmentRenderer(attachmentMiddleware);
  }, [attachmentMiddleware]);
  var avatarRenderer = (0, _react.useMemo)(function () {
    return createAvatarRenderer(avatarMiddleware);
  }, [avatarMiddleware]);
  var toastRenderer = (0, _react.useMemo)(function () {
    return createToastRenderer(toastMiddleware);
  }, [toastMiddleware]);
  var typingIndicatorRenderer = (0, _react.useMemo)(function () {
    return createTypingIndicatorRenderer(typingIndicatorMiddleware);
  }, [typingIndicatorMiddleware]);
  return _react.default.createElement(_Composer.default, _extends({
    activityRenderer: activityRenderer,
    activityStatusRenderer: activityStatusRenderer,
    attachmentRenderer: attachmentRenderer,
    avatarRenderer: avatarRenderer,
    sendBoxRef: sendBoxRef,
    toastRenderer: toastRenderer,
    typingIndicatorRenderer: typingIndicatorRenderer
  }, otherProps), function (_ref7) {
    var styleSet = _ref7.styleSet;
    return _react.default.createElement(_TypeFocusSink.default, {
      className: (0, _classnames.default)(ROOT_CSS + '', styleSet.root + '', className + ''),
      role: "complementary",
      sendFocusRef: sendBoxRef
    }, !styleSet.options.hideToaster && _react.default.createElement(_BasicToaster.default, {
      className: TOASTER_CSS + ''
    }), _react.default.createElement(_BasicTranscript.default, {
      className: TRANSCRIPT_CSS + ''
    }), _react.default.createElement(_BasicConnectivityStatus.default, {
      className: CONNECTIVITY_STATUS_CSS + ''
    }), !styleSet.options.hideSendBox && _react.default.createElement(_BasicSendBox.default, {
      className: SEND_BOX_CSS + ''
    }));
  });
};

var _default = BasicWebChat;
exports.default = _default;
BasicWebChat.defaultProps = _objectSpread({}, _Composer.default.defaultProps, {
  activityMiddleware: undefined,
  attachmentMiddleware: undefined,
  avatarMiddleware: undefined,
  className: ''
});
BasicWebChat.propTypes = _objectSpread({}, _Composer.default.propTypes, {
  activityMiddleware: _propTypes.default.func,
  attachmentMiddleware: _propTypes.default.func,
  avatarMiddleware: _propTypes.default.func,
  className: _propTypes.default.string
});